import cx from 'clsx';
import React from 'react';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  label?: string;
  value?: string | number;
  valueHtml?: string;
  variant?: string;
  dataQa: string;
}

const VerifyValueItem = ({ label, value, valueHtml, variant = '', dataQa }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={cx({ [style.fullHeight]: variant === 'full-height' })} data-qa={dataQa}>
      {label && <div className={style.verifyItemLabel}>{t(label)}</div>}
      {valueHtml ? (
        <div
          className={cx(style.verifyItemValue, style.verifyItemValueHtml)}
          dangerouslySetInnerHTML={{ __html: valueHtml }}
        />
      ) : (
        <div className={cx(style.verifyItemValue, { [style.fullHeight]: variant === 'full-height' })}>
          {value}
        </div>
      )}
    </div>
  );
};

export default VerifyValueItem;
